import { Injectable } from '@angular/core';

import { Organisation } from '@/organisations/models';
import { PersonalTaxFile } from '@/tax/models';
import { PersonType, getLocalizedPersonType } from '@/tax/models/person-type.enum';

export type SupportedGlobalInterpolationTag = 'organisation_name' | 'name_declarant' | 'name_partner'; //Example implementation
@Injectable({
    providedIn: 'root',
})
export class StringInterpolationService {
    private interpolationData = {
        'organisation_name': 'unknown organisation',
        'name_declarant': getLocalizedPersonType()[PersonType.Owner],
        'name_partner': getLocalizedPersonType()[PersonType.Partner],
    } as Record<SupportedGlobalInterpolationTag, string>;

    addGlobalInterpolations(data: Partial<Record<SupportedGlobalInterpolationTag, string>>) {
        this.interpolationData = Object.assign(this.interpolationData, data);
    }

    updateOrganisationInterpolations(org?: Organisation) {
        this.addGlobalInterpolations({ 'organisation_name': org?.name ?? 'no organisation' });
    }

    updateTaxInterpolations(taxFile?: PersonalTaxFile) {
        if (taxFile === undefined) {
            this.addGlobalInterpolations({
                'name_declarant': getLocalizedPersonType()[PersonType.Owner],
                'name_partner': getLocalizedPersonType()[PersonType.Partner],
            });
            return;
        }
        const info = taxFile.getHoldersInfo();
        this.addGlobalInterpolations({
            'name_declarant': info.declarantLabel,
            'name_partner': info.partnerLabel ?? getLocalizedPersonType()[PersonType.Partner],
        });
    }

    interpolateString(text: string, extraInterpolationData?: Record<string, string>): string {
        const dataMap = Object.assign(JSON.parse(JSON.stringify(this.interpolationData)), extraInterpolationData ?? {});
        let transformedString = text;
        //Fast shortcut to avoid regexes if not needed
        if (!text.includes('{') || !text.includes('}')) {
            return transformedString;
        }
        return transformedString.replace(/\{\s*([a-z0-9_]+)\s*\}/gi, (match, key) => {
            if (key === undefined) {
                return match;
            } else if (dataMap[key]) {
                return dataMap[key];
            } else {
                console.error(key, 'is not a known interpolation');
                return match;
            }
        });
    }
}
